export function match(param: string) {
	return param === "groups" || param === "users" || param === "roles";
}
